import { render, staticRenderFns } from "./UserTeamSelector.vue?vue&type=template&id=dc4b8982&scoped=true&"
import script from "./UserTeamSelector.vue?vue&type=script&lang=js&"
export * from "./UserTeamSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4b8982",
  null
  
)

export default component.exports